import { APP_DATA_SOURCE_SELECTION } from "app/action_types/app_intelligence_action_types";
import { swSettings } from "app/common/services/swSettings";
import { AppDataSources } from "app/pages/app-intelligence/common-components/app-solution-toggle/AppSolutionToggle";
import type { AnyAction } from "redux";

const getDefaultState = () => {
    return {
        selectedAppDataSource: swSettings?.user?.isInternalUser ? AppDataSources.PREMIUM_PLUS : undefined,
    };
};

export function appDataSource(state = getDefaultState(), action: AnyAction) {
    switch (action.type) {
        case APP_DATA_SOURCE_SELECTION: {
            return {
                selectedAppDataSource: action.payload,
            };
        }
        default:
            return state;
    }
}
